export function getOneLineAddress(obj) {
  return [
    obj?.prefecture,
    obj?.locality,
    obj?.address1,
    obj?.address2,
  ].filter(d => !!d).join(' ');
}
